import { SettingsSort } from '@griply/assets';
import { GoalOverviewRoadmapViewOptions } from '@griply/types';
import { useUpdateUserSettings } from 'features/user';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from 'shared/components/ui/icon-button';
import {
  PopupMenu,
  PopupMenuList,
  PopupMenuListItem,
  PopupMenuToggle,
} from 'shared/components/ui/popup-menu';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { useUser } from 'shared/hooks/use-user';

export type ExtraOptionsMenuProps = {
  view: GoalOverviewRoadmapViewOptions;
};

export const ExtraOptionsMenu: React.FC<ExtraOptionsMenuProps> = ({ view }) => {
  const { t } = useTranslation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { menuOpen, openMenu, closeMenu } = useOpenMenu();
  const isTimeline = view === GoalOverviewRoadmapViewOptions.Timeline;

  const user = useUser();
  const updateUserSettings = useUpdateUserSettings();
  // The Goals-list page reads/writes `goalsOverview.roadmap.*`; the standalone
  // Timeline page keeps its own `goalsOverview.timeline.*` so the two filter
  // independently.
  const displayOptions = isTimeline
    ? user?.settings?.goalsOverview?.timeline
    : user?.settings?.goalsOverview?.roadmap;
  const showCompletedGoals = displayOptions?.showCompletedGoals ?? true;

  const onShowCompletedGoals = (value: boolean) => {
    updateUserSettings(
      isTimeline
        ? { goalsOverview: { timeline: { showCompletedGoals: value } } }
        : { goalsOverview: { roadmap: { showCompletedGoals: value } } },
    );
  };

  return (
    <>
      <IconButton
        ref={buttonRef}
        icon={SettingsSort}
        strokeWidth={2}
        onClick={openMenu}
        highlighted={menuOpen}
        preventDrag
      />
      {menuOpen && (
        <PopupMenu
          referenceElement={buttonRef}
          onOutside={closeMenu}
          position="bottom-end"
        >
          <PopupMenuList>
            <PopupMenuListItem>
              <PopupMenuToggle
                label={t('general.labels.goals.show-completed-goals')}
                checked={showCompletedGoals}
                onChange={onShowCompletedGoals}
              />
            </PopupMenuListItem>
          </PopupMenuList>
        </PopupMenu>
      )}
    </>
  );
};
